<template>
  <div>
    <h2 id="formName" v-if="!childInputs && !LTChildOnboarding">{{ $t('Please fill in the information') }}</h2>
    <private-customer-info v-if="groupValue == 'FP' && !childInputs && !LTChildOnboarding"></private-customer-info>
    <private-customer-children-info
      v-if="groupValue == 'FP' && childInputs && !LTChildOnboarding"
    ></private-customer-children-info>
    <private-customer-children-info-lt
      v-if="groupValue == 'FP' && LTChildOnboarding"
    ></private-customer-children-info-lt>
    <business-customer-info v-if="groupValue == 'JP'"></business-customer-info>
  </div>
</template>

<script>
import PrivateCustomerInfo from '../components/PrivateCustomerInfo.vue'
import BusinessCustomerInfo from '../components/BusinessCustomerInfo.vue'
import PrivateCustomerChildrenInfo from '../components/PrivateCustomerChildrenInfo.vue'
import PrivateCustomerChildrenInfoLt from '../components/PrivateCustomerChildrenInfoLt.vue'
import { mapState, mapActions } from 'pinia'
import { useBookingStore } from '../store'
export default {
  name: 'PersonalView',
  data() {
    return {
      LTChildOnboarding: false,
    }
  },
  components: {
    PrivateCustomerInfo,
    BusinessCustomerInfo,
    PrivateCustomerChildrenInfo,
    PrivateCustomerChildrenInfoLt,
  },
  computed: {
    ...mapState(useBookingStore, ['groupValue', 'childInputs', 'appointmentType']),
  },
  watch: {},
  mounted() {
    if (this.appointmentType == 'child_onboardingLT14') {
      this.LTChildOnboarding = true
    }
  },
  methods: {
    ...mapActions(useBookingStore, ['setChildrenCount', 'setChildInputs']),
  },
}
</script>
